import { PricingFeatureTable } from '@/components/wpl/pricing/src/features-table/features-table';
import { usePricingContentContext } from '@/components/wpl/pricing/src/pricing-content-context.tsx';
import { QuotationsAdornment } from '@/components/wpl/pricing/src/pricing-faq/quotations';
import { PageHeading } from '@/components/wpl/pricing/src/pricing-page-layout/page-heading';
import { PricingPageLayout } from '@/components/wpl/pricing/src/pricing-page-layout/pricing-page-layout';
import { ParentScrollTracking } from '@/utils/scroll-tracking/parent-scroll-tracker';

import { PricingFaq } from '../../../../../../../../components/wpl/pricing/src/pricing-faq/pricing-faq';
import { JiraProductDiscoveryPricingPageProps } from '../../../../../../../../pages/software/jira/product-discovery/pricing/jira-product-discovery-pricing-page';
import { JPDBanner } from '../../../../banner/banner.tsx';
import JiraProductDiscoveryNavV2 from '../../../src/sections/product-nav';

import { JiraProductDiscoveryPriceFinder } from './sections/jira-product-discovery-price-finder';
import { JpdQuestionsCta } from './sections/jpd-questions-cta.tsx';

export const JiraProductDiscoveryPricingPageTemplate = (
	props: JiraProductDiscoveryPricingPageProps,
) => {
	const content = usePricingContentContext();
	return (
		<div>
			<PricingPageLayout
				nav={<JiraProductDiscoveryNavV2 />}
				banner={<JPDBanner />}
				showFallback={content?.hasError}
			>
				<ParentScrollTracking scrollTrackingEnabled={true} pageId="jpd-pricing-page">
					<PageHeading>{content?.headline}</PageHeading>
					<JiraProductDiscoveryPriceFinder
						pricing={props.pricing}
						countryCode={props.countryCode}
					/>
					<PricingFeatureTable
						title={content?.compareFeaturesTitle ?? undefined}
						comparePlans={content?.comparePlans ?? undefined}
						compareFeatures={content?.compareFeatures ?? undefined}
					/>
					<QuotationsAdornment>
						<ParentScrollTracking>
							<PricingFaq
								header={content?.getMoreDetailsTitle ?? undefined}
								planDetails={content?.additionalDetails ?? undefined}
							/>
						</ParentScrollTracking>
					</QuotationsAdornment>
					<JpdQuestionsCta />
				</ParentScrollTracking>
			</PricingPageLayout>
		</div>
	);
};
